export const GET_DEALERS_REQUEST = 'GET_DEALERS_REQUEST'
export const GET_DEALERS_SUCCESS = 'GET_DEALERS_SUCCESS'
export const GET_DEALERS_FAIL = 'GET_DEALERS_FAIL'